import React from 'react';
import SMSForm from '../components/sms/SMSForm';

import { Paper } from '@material-ui/core';


const SMSView = ({match}) => {

  return (
    <>
      <Paper elevation={2}>
        <SMSForm match={match} />
      </Paper>


    </>
  );
};


export default SMSView;